import { module } from 'modujs';
import { html } from '../utils/environment';
import { gsap } from 'gsap';
import { onRAF } from '../utils/onRAF';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
		if(!window.isMobile) {
			this.launchDelay = 2;

			this.spriteIteration = 115;

			this.$image = this.$('image')[0];
			this.path = this.getData('path');
			this.$canvas = this.$('canvas')[0];
			this.offCanvas = new OffscreenCanvas(0,0);
			this.ctx = this.$canvas.getContext('2d');
			this.offCtx = this.offCanvas.getContext('2d');

			this.resizeDebounce();

			this.$preloadImages = this.$('preloadImage');

			this.iterator = 0;
			this.loadedIterator = 0;

			this.progress = {
				value: 0
			};

			this.$value = this.$('value')[0];
		}

		this.load();

    }

	load() {

		if(window.hasSeenLoader) {
			this.call('setFirstLoad','Load');
			html.classList.add('has-loader-callback');
			html.classList.add('has-loader-seen');
			html.classList.add('has-loader-ready');

			return;
		}

		this.$preloadImages.forEach((image, imageIndex) => {
			// let padIterator = `${index}`.padStart(3,'0');
			// let imageName = `Loader${padIterator}.png`;
			
			// let image = new Image();
			image.src = image.getAttribute('data-load-src');

			image.addEventListener('load',() => {
				if(this.loadedIterator == 0) {
					this.rafIterator = 0;
					this.unregisterRAF = onRAF(() => this.play());
				}

				this.loadedIterator++;

				if(this.loadedIterator >= this.spriteIteration) {
					let imageName = `Loader000.png`;
					// this.$image.src = `${this.path}${imageName}`
					
					this.call('setFirstLoad', 'Load');

					if(!window.hasSeenLoader) {
						this.animIsNotReady = true;
						html.classList.add('has-loader-ready');
					}

					gsap.delayedCall(this.launchDelay, () => {
						this.animIsNotReady = false;
					});
				}

			});
		});

	}

	play() {		
		if(this.progress.value < 100) {
			this.offCtx.clearRect(0,0,this.w, this.h);
			this.ctx.clearRect(0,0,this.w, this.h);
			this.offCtx.drawImage(this.$preloadImages[0], 0, 0, this.w, this.h);
			this.ctx.drawImage(this.offCanvas,0,0,this.w,this.h);

			if(this.rafIterator < this.progress.value) {
				this.progress.value = Math.round(this.loadedIterator * 100 / this.spriteIteration);
			} else {
				this.progress.value = this.rafIterator;
			}
			this.$value.innerText = `${this.progress.value}`.padStart(3,'0');
		}

		if(!this.animIsNotReady && this.progress.value >= 100) {
			this.ctx.save();

			this.offCtx.save();
			this.offCtx.clearRect(0,0,this.w, this.h);
			this.ctx.clearRect(0,0,this.w, this.h);
			
			this.offCtx.drawImage(this.$preloadImages[this.iterator], 0, 0, this.w, this.h);
			// this.offCtx.fillStyle = 'red';
			// this.offCtx.arc(this.w/2, this.h/2, this.iterator*3, 0, Math.PI*2);
			// this.offCtx.fill();
			
			this.offCtx.restore();

			this.ctx.drawImage(this.offCanvas,0,0);

			this.ctx.restore();

			this.iterator++;			
			
			if(this.iterator == 25) {
				html.classList.add('has-loader-scaled');
			}
			if(this.iterator == 102) {
				html.classList.add('has-loader-precallback');
			}

			if(this.iterator >= this.spriteIteration) {
				
				this.unregisterRAF();
				html.classList.add('has-loader-callback');
				return;
			}
		}

		this.rafIterator++;
	}

	resize() {
        if (this.resizeTimeout != undefined) {
            this.resizeTimeout.kill();
        }
        this.resizeTimeout = gsap.delayedCall(0.3, () => {
            this.resizeDebounce();
        });
    }

	resizeDebounce() {
		this.w = parseInt(this.$canvas.parentNode.getBoundingClientRect().width);
		this.h = parseInt(this.$canvas.parentNode.getBoundingClientRect().height);
		this.$canvas.width = this.w;
		this.offCanvas.width = this.w;
		this.$canvas.height = this.h;
		this.offCanvas.height = this.h;
	}

	destroy() {
		if(!window.isMobile) {
			this.unregisterRAF();
		}
	}
	
}
